import Situation000 from './component/situation-000/index.vue';
import Situation100 from './component/situation-100/index.vue';
import Situation200 from './component/situation-200/index.vue';

export default {
  components: {
    Situation000,
    Situation100,
    Situation200,
  },
  props: {
    //使用场景
    //000:支付场景
    //100:授信还款场景
    //200:钱包充值场景
    situation: {
      type: String,
      default: `000`,
    },
  },
  data() {
    return {}
  },
  methods: {
    init(pParameter) {
      const __this = this;
      if (__this.situation === `000`) {
        __this.$refs.aSituation000.init(pParameter);
      }

      if (__this.situation === `100`) {
        __this.$refs.aSituation100.init(pParameter);
      }

      if (__this.situation === `200`) {
        __this.$refs.aSituation200.init(pParameter);
      }
    },
  },
  created() {
  }
}
